module.exports = __webpack_public_path__ + "static/img/78118A_X_all_20170731_LC.64dcfc2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/78118A_X_all_20170731_LC.png
// module id = sNhf
// module chunks = 0